module.exports = __webpack_public_path__ + "static/media/55637157_2519310768144099_9161457708166021120_o.40ce4b1d.jpg";